import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import { phoneNumberIsInternationalFormat } from "@limitless/portal/utils";
import LoginButton from "../buttons/login-button/LoginButton";
import { useMFASetupContext } from "../../hooks/mfa-setup/MFASetupContext";
import DialPrefixWithPhoneInput from "@limitless/modern/inputs/dial-prefix-with-phone-input/DialPrefixWithPhoneInput";
import { useLoginWrapperContext } from "../../../expert";
import { useExpertProfileContext } from "../../../expert";
const useStyles = makeStyles(theme => ({
  textInputStyle: {
    WebkitBoxShadow: `0 0 0 1000px ${theme.palette.contrast.light} inset`,
    backgroundColor: theme.palette.contrast.light,
    borderRadius: 4,
    marginBottom: 32,
    paddingLeft: 16,
    paddingRight: 16,
    maxWidth: 325
  },
  listboxStyle: {
    maxHeight: 120
  },
  paperStyle: {
    backgroundColor: theme.palette.contrast.light
  },
  autoCompleteRootStyle: {
    left: "-15px !important"
  },
  button: {
    width: 300
  }
}));
const MFAPhoneSubmit = ({
  mfaState,
  setMfaState,
  dialCodes
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const {
    submitPhoneNumber
  } = useMFASetupContext();
  const {
    mfaRequestCodeSuccessCB
  } = useLoginWrapperContext();
  const {
    profile
  } = useExpertProfileContext();
  const phoneIsValid = React.useMemo(() => phoneNumberIsInternationalFormat(mfaState.phoneNumber, dialCodes), [mfaState.phoneNumber]);
  const phoneSubmitHandler = async () => {
    setMfaState({
      ...mfaState,
      loading: true
    });
    mfaRequestCodeSuccessCB();
    submitPhoneNumber(mfaState, updatedState => setMfaState(updatedState), true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary",
    style: {
      marginBottom: 16
    }
  }, t("The phone number must be from your country of residence")), /*#__PURE__*/React.createElement(DialPrefixWithPhoneInput, {
    name: "mfaPhoneNumber",
    autoComplete: "off",
    placeholder: "Your Phone Number",
    id: "mfaPhoneInputField",
    handlePhoneInputChange: (dialCodeValue, phoneNumberValue) => setMfaState({
      ...mfaState,
      phoneNumber: dialCodeValue + phoneNumberValue
    }),
    value: mfaState.phoneNumber.trim(),
    classes: {
      root: classes.textInputStyle
    },
    inputProps: {
      onFocus: e => {
        e.currentTarget.setSelectionRange(mfaState.phoneNumber.length, mfaState.phoneNumber.length);
      }
    },
    dropdownListStyle: classes.listboxStyle,
    dropdownPaperStyle: classes.paperStyle,
    dropdownContainerStyle: classes.autoCompleteRootStyle,
    disableCountrySelection: true
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(LoginButton, {
    disabled: mfaState.submitPhoneScreen && !phoneIsValid || !mfaState.submitPhoneScreen,
    loading: mfaState.loading,
    id: "mfaSetupButton",
    onClick: phoneSubmitHandler,
    containerClasses: classes.button
  }, t("Request Code")), mfaState.errTxt && /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Box, {
    minHeight: 38
  }), /*#__PURE__*/React.createElement(Typography, {
    color: "error",
    variant: "subtitle1"
  }, t(mfaState.errTxt)))));
};
export default MFAPhoneSubmit;
MFAPhoneSubmit.propTypes = {
  mfaState: PropTypes.object,
  dialCodes: PropTypes.array,
  setMfaState: PropTypes.func
};